import { createLocalContext } from 'js/app/utils/createLocalContext';

import * as reducer from './reducer';

export const {
    withLocalProvider: withBingoListProvider,
    useLocalSelector: useBingoListSelector,
    useLocalDispatch: useBingoListDispatch
} = createLocalContext(reducer);
